import { Stack, Typography, Link } from '@mui/material'
import { TypographyProps } from '@mui/material/Typography'
import NextLink from 'next/link'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

type LinkToInfoProps = {
  href: string
  textBefore?: string
  linkText?: string
  textAfter?: string
  variant?: TypographyProps['variant']
  openInNewTab?: boolean
}

export const LinkToInfo = ({
  href,
  textBefore = '詳しくは',
  linkText = 'こちら',
  textAfter,
  variant = 'body2',
  openInNewTab = true,
}: LinkToInfoProps) => {
  const isInSentence = Boolean(textBefore || textAfter)
  const underlineStyle = isInSentence ? 'always' : 'none'

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap">
      <Typography variant={variant}>{textBefore}</Typography>
      <Link
        variant={variant}
        component={NextLink}
        href={href}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        underline={underlineStyle}
        sx={{
          mx: 0.5,
          display: openInNewTab ? 'flex' : 'inline',
          alignItems: openInNewTab ? 'center' : undefined,
          gap: openInNewTab ? 0.5 : undefined,
        }}
      >
        {linkText}
        {openInNewTab && <OpenInNewIcon sx={{ fontSize: '1rem' }} />}
      </Link>
      {textAfter && <Typography variant={variant}>{textAfter}</Typography>}
    </Stack>
  )
}
